module.exports = __webpack_public_path__ + "assets/img/report-repay-pp-tips.5d24e8b1.png";